/**
 * These values are set when creating a new Surfboard Order as source in the metadata payload
 * The webhooks order related messages published by the Surfboard payment gateway will contain this metadata information
 * Used for identifying at Surfboard webhooks
 */
export enum SURFBOARD_WEBHOOKS_EVENT_TYPE {
  ORDER_PAYMENT_COMPLETED = 'order.paymentcompleted',
  ORDER_PAYMENT_FAILED = 'order.paymentfailed',
  ORDER_PAYMENT_CANCELLED = 'order.paymentcancelled',
}